<template>
    <v-container fluid pa-0 class="error-page bg-light" justify-center>
        <v-layout text-xs-center justify-center align-center column class="error-code primary">
            404
        </v-layout>
        <v-layout justify-center text-xs-center>
            <v-layout ml-4 mr-4 column class="error-card elevation-4 white">
                <v-icon color="grey-5" >error_outline</v-icon>
                <p class="caption text-center">Oops. Nothing here...</p>
                <p class="text-center group">
                    <v-btn v-if="canGoBack" color="primary" push @click="goBack">
                        <v-icon>keyboard_arrow_left</v-icon>
                        Go back
                    </v-btn>
                    <v-btn color="primary" push @click="$router.replace('/')">
                        Go home
                        <v-icon>home</v-icon>
                    </v-btn>
                </p>
            </v-layout>
        </v-layout>
    </v-container>
</template>

<script>

export default {
    data() {
        return {
            canGoBack: window.history.length > 1
        };
    },
    methods: {
        goBack() {
            window.history.go(-1);
        }
    }
};
</script>

<style lang="stylus">
.error-page {
    .error-code {
        height: 50vh;
        width: 100%;
        padding-top: 15vh;

        @media (orientation: landscape) {
            font-size: 30vw;
        }

        @media (orientation: portrait) {
            font-size: 30vh;
        }

        color: rgba(255, 255, 255, 0.2);
        overflow: hidden;
    }

    .error-card {
        border-radius: 2px;
        margin-top: -50px;
        width: 80vw;
        max-width: 600px;
        padding: 25px;

        > i {
            font-size: 5rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/404/404.vue